module.exports = __webpack_public_path__ + "img/ecommerce-card-bg-dark.57a7a1c5.png";